import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: [],
  loading: false,
  error: null,
  totalPages: 0,
  page: 1,
};

const activeJobSlice = createSlice({
  name: "activeJob",
  initialState,
  reducers: {
    fetchActiveRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchActiveSuccess: (state, action) => {
      state.loading = false;
      state.active = action.payload.active;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.currentPage;
    },
    fetchActiveFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchActiveRequest,
  fetchActiveSuccess,
  fetchActiveFailure,
} = activeJobSlice.actions;

export default activeJobSlice.reducer;
